/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import LocationResponse from './LocationResponse';
import SupplyAppointmentResponse from './SupplyAppointmentResponse';
import SupplyResponse from './SupplyResponse';
import TankResponse from './TankResponse';

/**
* The CustomerResponse model module.
* @module model/CustomerResponse
* @version 2020-12-7
*/
export default class CustomerResponse {
    /**
    * Constructs a new <code>CustomerResponse</code>.
    * 顧客
    * @alias module:model/CustomerResponse
    * @class
    * @param id {Number} 顧客ID
    * @param name {String} 顧客名
    * @param code {String} 顧客コード
    * @param address {String} 住所
    * @param tel {String} 電話番号
    * @param groupId {Number} グループID
    * @param deliveryGroupId {Number} 配送グループID
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(id, name, code, address, tel, groupId, deliveryGroupId, updatedAt) {
        
        
        this['id'] = id;
        this['name'] = name;
        this['code'] = code;
        this['address'] = address;
        this['tel'] = tel;
        this['groupId'] = groupId;
        this['deliveryGroupId'] = deliveryGroupId;
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>CustomerResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CustomerResponse} obj Optional instance to populate.
    * @return {module:model/CustomerResponse} The populated <code>CustomerResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomerResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('location')) {
                obj['location'] = LocationResponse.constructFromObject(data['location']);
            }
            if (data.hasOwnProperty('tel')) {
                obj['tel'] = ApiClient.convertToType(data['tel'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('groupId')) {
                obj['groupId'] = ApiClient.convertToType(data['groupId'], 'Number');
            }
            if (data.hasOwnProperty('deliveryGroupId')) {
                obj['deliveryGroupId'] = ApiClient.convertToType(data['deliveryGroupId'], 'Number');
            }
            if (data.hasOwnProperty('latestSupply')) {
                obj['latestSupply'] = SupplyResponse.constructFromObject(data['latestSupply']);
            }
            if (data.hasOwnProperty('latestAppointment')) {
                obj['latestAppointment'] = SupplyAppointmentResponse.constructFromObject(data['latestAppointment']);
            }
            if (data.hasOwnProperty('volumeMargin')) {
                obj['volumeMargin'] = ApiClient.convertToType(data['volumeMargin'], 'Number');
            }
            if (data.hasOwnProperty('priorTankId')) {
                obj['priorTankId'] = ApiClient.convertToType(data['priorTankId'], 'Number');
            }
            if (data.hasOwnProperty('tanks')) {
                obj['tanks'] = ApiClient.convertToType(data['tanks'], [TankResponse]);
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 顧客ID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * 顧客名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * 顧客コード
    * @member {String} code
    */
    'code' = undefined;
    /**
    * 住所
    * @member {String} address
    */
    'address' = undefined;
    /**
    * @member {module:model/LocationResponse} location
    */
    'location' = undefined;
    /**
    * 電話番号
    * @member {String} tel
    */
    'tel' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * グループID
    * @member {Number} groupId
    */
    'groupId' = undefined;
    /**
    * 配送グループID
    * @member {Number} deliveryGroupId
    */
    'deliveryGroupId' = undefined;
    /**
    * @member {module:model/SupplyResponse} latestSupply
    */
    'latestSupply' = undefined;
    /**
    * @member {module:model/SupplyAppointmentResponse} latestAppointment
    */
    'latestAppointment' = undefined;
    /**
    * 残量余裕値
    * @member {Number} volumeMargin
    */
    'volumeMargin' = undefined;
    /**
    * 最優先タンク
    * @member {Number} priorTankId
    */
    'priorTankId' = undefined;
    /**
    * タンク
    * @member {Array.<module:model/TankResponse>} tanks
    */
    'tanks' = undefined;
    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
